// extracted by mini-css-extract-plugin
export default {"container":"Rp-z","heading":"Sp-z","text":"Tp-z","info":"Up-z","link":"Vp-z","fullMaxWidth":"Wp-z"};